import { VirtualAssistantProductCard } from '@/components/virtual-assistant/virtual-assistant-product-card';
import styles from './assistant-bubble.module.scss';
import { VirtualAssistantButton } from './virtual-assistant-button';
import { VirtualAssistantThinking } from './virtual-assistant-thinking';
import { AssistantMessage } from './virtual-assistant-timeline';

type Props = {
	message: AssistantMessage;
	onSuggestionClick: (s: string) => void;
};

export function AssistantBubble({ message, onSuggestionClick }: Props) {
	const isPending = message.status === 'pending';

	return (
		<div className={styles.column}>
			<div className={styles.row}>
				<VirtualAssistantThinking thinking={isPending} />
				{message?.text?.trim() !== '' && (
					<div className={styles.bubble} dangerouslySetInnerHTML={{ __html: message.text }} />
				)}
			</div>

			{message.products && message.products.length > 0 && (
				<div className={styles.products}>
					{message.products &&
						message.products.map((p, idx) => (
							<VirtualAssistantProductCard key={p.productName} product={p} rank={idx + 1} />
						))}
				</div>
			)}

			{!isPending && message.suggestions && (
				<div className={styles.suggestions}>
					{message.suggestions.map((s) => (
						<VirtualAssistantButton
							key={s}
							variant="secondary"
							label={s}
							size="sm"
							onClick={() => onSuggestionClick(s)}
						/>
					))}
				</div>
			)}
		</div>
	);
}
